import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormSelect from '../form/FormSelect';
import { getUserAssignmentOptions } from '../../libs/user';
import { withStyles } from '@material-ui/core';
import LocationContainer from '../../containers/Location';

const styles = () => {
	return {};
};

class UserScheduleTypeSelect extends PureComponent {
	componentDidMount() {
		const { locations, searchLocations } = this.props;
		if (_.isEmpty(locations)) {
			searchLocations();
		}
	}

	render() {
		const { locations, selectedLocationId } = this.props;

		const pickToShow = {
			padding: 20,
			background: '#f7f7f7',
			border: '1px solid #ddd',
			color: '#333',
			borderRadius: 2,
			fontSize: '13px',
		};

		if (!selectedLocationId || _.isEmpty(locations)) {
			return <div style={pickToShow}>First pick a location to see available Schedule Types</div>;
		}

		const location = _.find(locations, { locationId: selectedLocationId });
		if (!location || !location.state) {
			return <div style={pickToShow}>First pick a location to see available Schedule Types</div>;
		}

		const { state } = location;
		const optionsForState = getUserAssignmentOptions({ state });
		return <FormSelect {...this.props} options={optionsForState} />;
	}
}

UserScheduleTypeSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	classes: PropTypes.object,
	helpText: PropTypes.string,
	selectedLocationId: PropTypes.number,
};

export default _.flow([withStyles(styles), LocationContainer])(UserScheduleTypeSelect);
